/**
 * Page changement de mot de passe
 * Wrapper autour du composant PasswordSettings du module auth
 */

import { useAuth, PasswordSettings } from '@features/auth';

export function PasswordSettingsPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <PasswordSettings
        userId={user.id}
        lastPasswordChange={user.lastPasswordChange?.toISOString()}
      />
    </div>
  );
}
